import { T2 } from "../../../styles/titles";
import { Button, Container } from "../styles";
import LoadingOverlay from "../../../components/LoadingOverlay";
import { useEffect, useState } from "react";
import { BillingPanelTableData, FormValues, TotalsData } from "../types";
import LiveTable from "./components/liveTable";
import { Totals } from "./components/totals/totals";
import BillingPanelService from "./service/BillingPanelService";
import { FormFilter } from "./components/filter/filters";
import { can, PortalPermissions } from "../../../config/permissions";

const BillingPanel: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState<BillingPanelTableData | null>(
    null
  );
  const [pageSize, setPageSize] = useState<number>(20);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totals, setTotals] = useState<TotalsData | null>(null);
  const billingPanelService = new BillingPanelService();
  const getInitialFilterData = () => {
    const today = new Date();
    return {
      month: today.getMonth() + 1,
      year: today.getFullYear(),
      merchantId: "",
      serialNumber: "",
      billingType: -1,
    };
  };

  const [filterData, setFilterData] = useState<any>(getInitialFilterData());

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const data = await billingPanelService.getBillings(
        currentPage,
        pageSize,
        filterData
      );
      setTotals({
        totalValue: data.totalValue,
        totalPending: data.totalPending,
        totalPayed: data.totalPayed,
        totalRecords: data.rowCount,
        totalExemptValue: data.totalExemptValue,
        totalExemptPos: data.totalExemptPos,
      });
      setTableData({
        records: data.records || [],
        count: data.rowCount || 0,
      });
    } catch (error) {
      console.error("Erro ao buscar nos dados: ", error);
    } finally {
      setIsLoading(false);
    }
  };


  useEffect(() => {
    
      fetchData();
    
  }, [filterData, currentPage, pageSize]);

  const handleDownload = async (filter?: FormValues) => {
    setIsLoading(true);
    const response = await billingPanelService.downloadBillingPanelXls(filter);

    if (response) {
      const objectUrl = window.URL.createObjectURL(response);
      const a = document.createElement("a");
      a.href = objectUrl;
      a.download = "Det Menu de Cobrancas.xlsx"; // Nome do arquivo
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(objectUrl);
      document.body.removeChild(a);
    }
    setIsLoading(false);
  };

  return (
    <Container>
      <LoadingOverlay show={isLoading} relative />

      <T2>Menu de Cobranças</T2>
      {totals && <Totals data={totals} />}
      <FormFilter getFilters={(data) => setFilterData(data)} />

      {can(PortalPermissions.cobrancas.menu.exportar) && (
        <Button
          onClick={() => handleDownload(filterData)}
          style={{
            marginBottom: "12px",
            marginRight: "24px",
            width: "150px",
            alignSelf: "start",
          }}
        >
          Download xlsx
        </Button>
      )}

      {tableData && (
        <LiveTable
          data={tableData}
          currentPage={currentPage}
          pageSize={pageSize}
          onPageChange={setCurrentPage}
          onPageSizeChange={setPageSize}
        />
      )}
    </Container>
  );
};

export default BillingPanel;
